import React, { Component } from 'react';
import Select from 'react-select';

import 'react-select/dist/react-select.css';

class SelectRemoteWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsSelect: props.options ? props.options.enumOptions : [],
    };
  }

  componentDidMount() {
    const { value, schema, onChange } = this.props;
    if (
      (value === undefined || value === null || value === '') &&
      schema &&
      schema.default !== undefined
    ) {
      onChange(schema.default);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      optionsSelect: nextProps.options ? nextProps.options.enumOptions : [],
    });
  }

  render() {
    const currentValue =
      this.props.value !== undefined &&
      this.props.value !== null &&
      this.props.value !== ''
        ? this.props.value
        : this.props.schema && this.props.schema.default;

    return (
      <div>
        <Select
          placeholder={this.props.schema.title}
          name="singleSelect"
          value={currentValue}
          options={this.state.optionsSelect}
          required={this.props.required}
          onChange={(event) =>
            event !== null
              ? this.props.onChange(event.value)
              : this.props.onChange(undefined)
          }
        />
      </div>
    );
  }
}

export default SelectRemoteWidget;



// WEBPACK FOOTER //
// ./src/lib/widget-select.js